import QTable from 'quasar/src/components/table/QTable.js';

export const adminInvoiceBillingInfoTableColumns = (): QTable['columns'] => [
  {
    name: 'legal_name',
    field: 'legal_name',
    label: 'نام حقوقی',
    align: 'center',
    style: 'max-width: 300px;width:200px'
  },
  {
    name: 'legal_national_code',
    field: 'legal_national_code',
    label: 'شناسه ملی',
    align: 'center'
  },
  {
    name: 'legal_financial_code',
    field: 'legal_financial_code',
    label: 'شناسه اقتصادی',
    align: 'center'
  },
  {
    name: 'legal_registry_code',
    field: 'legal_registry_code',
    label: 'شناسه ثبت',
    align: 'center'
  },
  {
    name: 'legal_address',
    field: 'legal_address',
    label: 'آدرس',
    align: 'center',
    style: 'width:200px'
  },
  {
    name: 'legal_zip_code',
    field: 'legal_zip_code',
    label: 'کدپستی',
    align: 'center'
  },
  {
    name: 'legal_tell',
    field: 'legal_tell',
    label: 'تلفن',
    align: 'center'
  },
  {
    name: 'natural_name',
    field: 'natural_name',
    label: 'نام حقیقی',
    align: 'center',
    style: 'max-width: 300px;width:200px'
  },
  {
    name: 'natural_melli_code',
    field: 'natural_melli_code',
    label: 'کد ملی',
    align: 'center'
  },
  {
    name: 'natural_address',
    field: 'natural_address',
    label: 'آدرس',
    align: 'center',
    style: 'width:300px'
  },
  {
    name: 'natural_zip_code',
    field: 'natural_zip_code',
    label: 'کدپستی',
    align: 'center'
  },
  {
    name: 'natural_tell',
    field: 'natural_tell',
    label: 'تلفن',
    align: 'center'
  }
]
